import { getLongestText } from "utils/textLength";
import moment from "moment";

export const storyConverter = {
  fromFirestore: (snapshot, options) => {
    const story = snapshot.data(options);
    const id = snapshot.id;

    const temp = story.title?.replace(/\*/g, "") || "Sin título";
    const name = temp.includes(":") ? temp.split(":")[1].trim() : temp;

    return {
      _id: id,
      author: story.author,
      builtWith: story.built_with || "images",
      covers: {
        landscape: story.cover_landscape_url,
        portrait: story.cover_portrait_url,
      },
      createdAt: story.created_at,
      disabled: !story.pdf_url && !story.pages?.length,
      file: story.pdf_url,
      image: story.cover_landscape_url,
      isPublic: [true, "true"].includes(story.is_public),
      maxLength: getLongestText(story.pages || []),
      name: name.charAt(0).toUpperCase() + name.slice(1),
      pages: story.pages,
      summary: story.summary || story.pages?.[0]?.text,
      thumbs: {
        landscape: story.thumb_landscape_url,
        portrait: story.thumb_portrait_url,
      },
      userId: story.user_id,
      year: moment(story.created_at?.toDate()).format("YYYY"),
    };
  },
  toFirestore: (story) => {
    delete story.id;
    return {
      ...story,
    };
  },
};
